import { Field, SelectSizeVariant } from '@payaca/ambrosia';
import { FC } from 'react';

import useGetMyAvailableTags from '@/api/queries/me/useGetMyAvailableTags';

import TagSelectCombobox from '@payaca/components/tagSelectCombobox/TagSelectCombobox';
import UntitledIcon from '@payaca/untitled-icons';
import { ExtraPickerProps } from '../../../types/complexConditionDef';

type ProjectHasTagExtra = {
  tagPublicId: string;
  tagName: string;
  tagColour: string;
};

const TagExtraPicker: FC<ExtraPickerProps<ProjectHasTagExtra>> = (props) => {
  const { value, onChange, errors } = props;
  const { data: tags = [] } = useGetMyAvailableTags();

  return (
    <Field.Legacy
      className="mt-2"
      validationState={
        errors.tagPublicId
          ? { isValid: false, validationMessages: [errors.tagPublicId] }
          : undefined
      }
    >
      <div className="relative flex gap-2 items-center">
        <UntitledIcon name="corner-down-right.3" className="size-5 shrink-0" />

        <Field.Label className="sr-only">Tag</Field.Label>

        <TagSelectCombobox
          sizeVariant={SelectSizeVariant.SM}
          availableTags={tags.map((tag) => ({
            id: tag.publicId,
            tagText: tag.name,
            tagColour: tag.colour || '',
          }))}
          value={value.tagPublicId ?? ''}
          multiple={false}
          placeholder="Select a tag..."
          onChange={(tagPublicId) => {
            const tag = tags.find((t) => t.publicId === tagPublicId);
            onChange({
              tagPublicId,
              tagName: tag?.name ?? '',
              tagColour: tag?.colour ?? '',
            });
          }}
        />
      </div>
    </Field.Legacy>
  );
};

export default TagExtraPicker;
